export default __webpack_public_path__ + "static/Commercial-Dumpsters-ec176b702d977191ee7f99cb23d5234f.jpg";